import React, { useState, useEffect } from "react"
import { withStyles } from "@material-ui/core/styles"
import styles from "./styles"
import { InputBase, Box, Button } from "@material-ui/core"
import Posts from "../../../../components/Posts"
import ActionBar from "../../../../components/ActionBar"
import PagesGrid from "../../../../components/PagesGrid"
import SearchIcon from "@material-ui/icons/Search"
import { useSelector, useDispatch } from "react-redux"
import { getPosts } from "actions/posts"
import { getEmailTags, getEmailsWithTags } from "actions/organization"
import { openSnackBar } from "actions/snack-bar"

const sorts = [
  {
    name: "Creator",
    getVal: val => val.first_name + " " + val.last_name
  },
  {
    name: "Expires",
    getVal: val => new Date(val.created).getTime()
  }
]

// const filters = [
//   {
//     name: "Posted",
//     filter: post => post.posted
//   },
//   {
//     name: "Not Posted",
//     filter: post => !post.posted
//   }
// ]

const RecentPosts = ({ classes }) => {
  const dispatch = useDispatch()
  const [selectedArray, setSelectedArray] = useState([])
  const [searchFilter, setSearchFilter] = useState("")
  const [currentFilter, setCurrentFilter] = useState("submitted")
  const [sort, setSort] = useState(null)
  const [submittedClicked, setSubmittedClicked] = useState(true)
  const [publishedClicked, setPublishedClicked] = useState(false)
  const posts = useSelector(state => state.posts.data)
  const handleSearch = e => {
    const searchValue = e.target.value
    setSearchFilter(searchValue)
  }
  const { id, emailsWithTags = [], tags = [] } = useSelector(
    state => state.organization.currentOrg
  )

  useEffect(() => {
    if (id && tags.length === 0) {
      dispatch(getEmailTags(id)).catch(() => {
        openSnackBar({ message: "Error getting email tags" })
      })
    }
  }, [id])

  useEffect(() => {
    if (id && emailsWithTags.length === 0) {
      dispatch(getEmailsWithTags(id)).catch(err => {
        console.log(err)
        dispatch(openSnackBar({ message: "Error getting emails" }))
      })
    }
  }, [id])

  const handleSelectCard = id => {
    setSelectedArray(
      selectedArray.includes(id)
        ? selectedArray.filter(element => element !== id)
        : [...selectedArray, id]
    )
  }

  const handleSubmitted = () => {
    if (currentFilter === "submitted") {
      setCurrentFilter("submitted")
    } else {
      setCurrentFilter("submitted")
      setSubmittedClicked(true)
      setPublishedClicked(false)
    }
  }
  const handlePublished = () => {
    if (currentFilter === "published") {
      setCurrentFilter("published")
    } else {
      setCurrentFilter("published")
      setPublishedClicked(true)
      setSubmittedClicked(false)
    }
  }

  useEffect(() => {
    dispatch(getPosts("all"))
  }, [])

  let filter = ""
  if (currentFilter === "submitted") {
    filter = {
      name: "Submitted",
      filter: post => !post.posted
    }
  } else if (currentFilter === "published") {
    filter = {
      name: "Published",
      filter: post => post.posted
    }
  }

  return (
    <PagesGrid
      actionBar={
        <ActionBar
          buttons={
            <Box>
              <Button
                variant={"text"}
                onClick={handleSubmitted}
                className={
                  !submittedClicked
                    ? classes.submittedButtonContainer
                    : classes.submittedButtonContainerActive
                }
              >
                Submitted
              </Button>
              <Button
                className={
                  !publishedClicked
                    ? classes.publishedButtonContainer
                    : classes.publishedButtonContainerActive
                }
                variant={"text"}
                onClick={handlePublished}
              >
                Published
              </Button>
            </Box>
          }
          sorts={sorts}
          setSort={setSort}
          sort={sort}
          searchBar={
            <div className={classes.searchBar}>
              <SearchIcon className={classes.searchIcon} />
              <InputBase
                placeholder="Search"
                className={classes.searchInput}
                onChange={e => handleSearch(e)}
              />
            </div>
          }
          // filters={filters}
          // setFilter={setFilter}
          // filter={filter}
        />
      }
      content={
        posts && (
          <Posts
            sort={sort}
            filter={filter}
            searchFilter={searchFilter}
            handleSelectCard={handleSelectCard}
          />
        )
      }
    />
  )
}

export default withStyles(styles)(RecentPosts)



// WEBPACK FOOTER //
// ./src/pages/Admin/pages/RecentPosts/index.jsx